import { Component, OnInit, ViewChild, Inject, ElementRef } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { ActivatedRoute } from '@angular/router';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-invoice-item-detail',
  templateUrl: './invoice-item-detail.component.html',
  styleUrls: ['./invoice-item-detail.component.css']
})
export class InvoiceItemDetailComponent implements OnInit {

  search_obj = {
    'placeholder': 'اسم الصنف / رقم الصنف', 'class_name': 'midField',
    'table_list': [{
      'table_name': '`main_item`',
      'selected_no': 'sub_item_no',
      'field_list': ['main_item_name', 'main_item_name_en'],
      'join_table': '`sub_item`',
      'join_condition': " AND `main_item`.`main_item_id` = `sub_item`.`main_item_id`"
    }]
  };

  private dp = [];
  displayedColumns = ['invoice_no', 'invoice_date', 'final_total', 'payment_method', 'sub_item_no',
    'sub_item_name', 'unit_name', 'price', 'count', 'total_price', 'discount', 'tax_name', 'tax_amount', 'item_total'];
  dataSource = new MatTableDataSource(this.dp);

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('TABLE') table: ElementRef;

  model = { 'from_date': new Date(), 'to_date': new Date(), 'title': '', 'sub_item_no': '', 'rep_type': 'detail' };

  type = '';
  no = '';
  name = '';
  back_link = '';

  Sale_Detail; Purchases_Detail; Cash; Bank; Visa; credit; Name; Number;
  From_Date_Msg; To_Date_Msg

  constructor(private utils: Utils, private applicationConstants: ApplicationConstants,
    private queryList: QueryList, public dialog: MatDialog, private route: ActivatedRoute,
    public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Sale_Detail').subscribe((res: string) => {
      this.Sale_Detail = res;
    });

    translate.get('Purchases_Detail').subscribe((res: string) => {
      this.Purchases_Detail = res;
    });

    translate.get('Cash').subscribe((res: string) => {
      this.Cash = res;
    });

    translate.get('Bank').subscribe((res: string) => {
      this.Bank = res;
    });

    translate.get('Visa').subscribe((res: string) => {
      this.Visa = res;
    });

    translate.get('Debit').subscribe((res: string) => {
      this.credit = res;
    });

    translate.get('Name').subscribe((res: string) => {
      this.Name = res;
    });

    translate.get('Number').subscribe((res: string) => {
      this.Number = res;
    });

    translate.get('From_Date_Msg').subscribe((res: string) => {
      this.From_Date_Msg = res;
    });

    translate.get('To_Date_Msg').subscribe((res: string) => {
      this.To_Date_Msg = res;
    });
  }

  ngOnInit() {
    //this.model['from_date'] = undefined;

    this.route.params.subscribe(params => {
      if (params['type'] != undefined && params['no'] != undefined) {
        this.type = params['type'];
        this.no = params['no'];

        ////////////////////////// CUSTOMER //////////////////////////

        if (this.type == 'customer') {
          this.model['title'] = this.Sale_Detail;
          this.back_link = '../../../customer_list';
          let customer;
          let query = "SELECT `customer_name` FROM `customer` WHERE `acct_number` = '" + this.no + "' AND `status` = '1'";
          let obj = { cmd: 'getList', query: query };
          this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
            .subscribe(data => {
              this.applicationConstants.appComp.hideBusyCursor();
              customer = data.data['list'];
              this.name = customer['0']['customer_name'];
            });
          this.search();
        }

        ////////////////////////// SUPPLIER //////////////////////////

        else if (this.type == 'supplier') {
          this.model['title'] = this.Purchases_Detail;
          this.back_link = '../../../supplier_list';
          let supplier;
          let query = "SELECT `supplier_name` FROM `supplier` WHERE `supplier_no` = '" + this.no + "' AND `status` = '1'";
          let obj = { cmd: 'getList', query: query };
          this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
            .subscribe(data => {
              this.applicationConstants.appComp.hideBusyCursor();
              supplier = data.data['list'];
              this.name = supplier['0']['supplier_name'];
            });
          this.search();
        }
      }
    });
  }

  onChangeSearch = function (search_result: object) {
    this.model['sub_item_no'] = search_result['no'];
  }

  search() {
    if (this.model['from_date'] == undefined || this.model['from_date'].toString() == '') {
      alert(this.From_Date_Msg);
      return;
    }

    if (this.model['to_date'] == undefined || this.model['to_date'].toString() == '') {
      alert(this.To_Date_Msg);
      return;
    }
    this.dp = [];
    let condition = "";
    let query;

    if (this.model['from_date'] != undefined) {
      let from_date = this.model['from_date'].getFullYear() + "-" + (this.model['from_date'].getMonth() + 1) + "-" +
        this.model['from_date'].getDate() + " 00:00:00";
      if (this.type == 'customer')
        condition += " AND `invoice`.`invoice_date` >= '" + from_date + "'";
      else if (this.type == 'supplier')
        condition += " AND `supplier_invoice`.`invoice_date` >= '" + from_date + "'";
    }

    if (this.model['to_date'] != undefined) {
      let to_date = this.model['to_date'].getFullYear() + "-" + (this.model['to_date'].getMonth() + 1) + "-" +
        this.model['to_date'].getDate() + " 23:59:59";
      if (this.type == 'customer')
        condition += " AND `invoice`.`invoice_date` <= '" + to_date + "'";
      else if (this.type == 'supplier')
        condition += " AND `supplier_invoice`.`invoice_date` <= '" + to_date + "'";
    }

    if (this.model['sub_item_no'] != '')
      condition += " AND `sub_item`.`sub_item_no` = '" + this.model['sub_item_no'] + "'";

    ////////////////////////// CUSTOMER //////////////////////////

    if (this.type == 'customer') {
      if (this.model['rep_type'] == 'detail') {
        query = "SELECT `invoice_item`.*, `unit`.`unit_name`, `invoice`.`invoice_no`," +
          " `invoice`.`invoice_date`, `invoice`.`payment_method`, `sub_item`.`sub_item_no`," +
          " (`invoice`.`total` + `invoice`.`tax` - `invoice`.`discount`) AS 'final_total'," +
          " (CASE WHEN (`invoice_item`.`tax_no` = '' OR `invoice_item`.`tax_no` = '0') THEN '' ELSE " +
          "(SELECT `tax`.`tax_name_ar` FROM `tax` WHERE `tax`.`status` = '1' AND `tax`.`acct_number` = " +
          "`invoice_item`.`tax_no`) END) AS 'tax_name' FROM `invoice_item`, `invoice`, `unit`, `sub_item`" +
          " WHERE `invoice_item`.`unit_id` = `unit`.`unit_id` AND `invoice_item`.`invoice_no` = `invoice`.`invoice_no`" +
          " AND `invoice_item`.`status` = '1' AND `invoice`.`customer_no` = '" + this.no +
          "' AND `sub_item`.`sub_item_number` = `invoice_item`.`sub_item_number`" + condition;
      }

      else if (this.model['rep_type'] == 'total') {
        query = "SELECT `invoice_item`.*, SUM(`invoice_item`.`count`) AS 'qty', `unit`.`unit_name`, `invoice`.`invoice_no`," +
          " `invoice`.`invoice_date`, `invoice`.`payment_method`, `sub_item`.`sub_item_no`," +
          " (`invoice`.`total` + `invoice`.`tax` - `invoice`.`discount`) AS 'final_total'," +
          " (CASE WHEN (`invoice_item`.`tax_no` = '' OR `invoice_item`.`tax_no` = '0') THEN '' ELSE " +
          "(SELECT `tax`.`tax_name_ar` FROM `tax` WHERE `tax`.`status` = '1' AND `tax`.`acct_number` = " +
          "`invoice_item`.`tax_no`) END) AS 'tax_name' FROM `invoice_item`, `invoice`, `unit`, `sub_item`" +
          " WHERE `invoice_item`.`unit_id` = `unit`.`unit_id` AND `invoice_item`.`invoice_no` = `invoice`.`invoice_no`" +
          " AND `invoice_item`.`status` = '1' AND `invoice`.`customer_no` = '" + this.no +
          "' AND `sub_item`.`sub_item_number` = `invoice_item`.`sub_item_number`" + condition + " GROUP BY `invoice_item`.`sub_item_number`";
      }


      // let query = "SELECT `invoice_item`.*, `unit`.`unit_name`, `invoice`.`invoice_no`," +
      //   " `invoice`.`invoice_date`, `invoice`.`payment_method`, (`invoice`.`total` + `invoice`.`tax`" +
      //   " - `invoice`.`discount`) AS 'final_total', (CASE WHEN (`invoice_item`.`tax_no` = '' OR " +
      //   "`invoice_item`.`tax_no` = '0') THEN '' ELSE (SELECT `tax`.`tax_name_ar` FROM `tax` WHERE " +
      //   "`tax`.`status` = '1' AND `tax`.`acct_number` = `invoice_item`.`tax_no`) END) AS 'tax_name' " +
      //   "FROM `invoice_item`, `invoice`, `unit` WHERE `invoice_item`.`unit_id` = `unit`.`unit_id` AND " +
      //   "`invoice_item`.`invoice_no` = `invoice`.`invoice_no` AND `invoice_item`.`status` = '1' AND " +
      //   "`invoice`.`customer_no` = '" + this.no + "'" + condition;

      console.log(query);
    }

    ////////////////////////// SUPPLIER //////////////////////////

    else if (this.type == 'supplier') {
      query = "SELECT `supplier_invoice_item`.*, `unit`.`unit_name`, `sub_item`.`sub_item_no`," +
        " `supplier_invoice`.`invoice_no`, `supplier_invoice`.`invoice_date`, `supplier_invoice`.`payment_method`," +
        " (`supplier_invoice`.`amount` + `supplier_invoice`.`tax` - `supplier_invoice`.`discount`) AS 'final_total'," +
        " (CASE WHEN (`supplier_invoice_item`.`tax_no` = '' OR `supplier_invoice_item`.`tax_no` = '0') THEN ''" +
        " ELSE (SELECT `tax`.`tax_name_ar` FROM `tax` WHERE `tax`.`status` = '1' AND `tax`.`acct_number` = " +
        "`supplier_invoice_item`.`tax_no`) END) AS 'tax_name' FROM `supplier_invoice_item`, `supplier_invoice`, " +
        "`unit`, `sub_item` WHERE `supplier_invoice_item`.`unit_id` = `unit`.`unit_id` AND `supplier_invoice_item`.`invoice_no` =" +
        " `supplier_invoice`.`invoice_no` AND `supplier_invoice_item`.`status` = '1' AND `supplier_invoice`.`supplier_no` = '" + this.no +
        "' AND `sub_item`.`sub_item_number` = `supplier_invoice_item`.`sub_item_number` " + condition;

      // "SELECT `supplier_invoice_item`.*, `unit`.`unit_name`, `supplier_invoice`.`invoice_no`," +
      // " `supplier_invoice`.`invoice_date`, `supplier_invoice`.`payment_method`," +
      // " (`supplier_invoice`.`amount` + `supplier_invoice`.`tax` - `supplier_invoice`.`discount`) AS 'final_total'," +
      // " '00' AS 'sub_item_no', (CASE WHEN (`supplier_invoice_item`.`tax_no` = '' OR `supplier_invoice_item`.`tax_no` = '0')" +
      // " THEN '' ELSE (SELECT `tax`.`tax_name_ar` FROM `tax` WHERE `tax`.`status` = '1' AND `tax`.`acct_number` = " +
      // "`supplier_invoice_item`.`tax_no`) END) AS 'tax_name' FROM `supplier_invoice_item`, `supplier_invoice`, " +
      // "`unit` WHERE `supplier_invoice_item`.`unit_id` = `unit`.`unit_id` AND `supplier_invoice_item`.`invoice_no`" +
      // " = `supplier_invoice`.`invoice_no` AND `supplier_invoice_item`.`status` = '1' AND `supplier_invoice`.`supplier_no` = '" + this.no +
      // "' AND (`supplier_invoice_item`.`sub_item_number` = '' OR `supplier_invoice_item`.`sub_item_number` = '0'" +
      // " OR `supplier_invoice_item`.`sub_item_number` = 'undefined') " + condition

      console.log(query);

      // let obj = { cmd: 'getList', query: query };
      // this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      //   .subscribe(data => {
      //     this.applicationConstants.appComp.hideBusyCursor();
      //     this.dp = data.data['list'];
      //     let query = "SELECT `supplier_invoice_item`.*, `unit`.`unit_name`, `supplier_invoice`.`invoice_no`," +
      //       " `supplier_invoice`.`invoice_date`, `supplier_invoice`.`payment_method`," +
      //       " (`supplier_invoice`.`amount` + `supplier_invoice`.`tax` - `supplier_invoice`.`discount`) AS 'final_total'," +
      //       " '' AS 'sub_item_no', (CASE WHEN (`supplier_invoice_item`.`tax_no` = '' OR `supplier_invoice_item`.`tax_no` = '0')" +
      //       " THEN '' ELSE (SELECT `tax`.`tax_name_ar` FROM `tax` WHERE `tax`.`status` = '1' AND `tax`.`acct_number` = " +
      //       "`supplier_invoice_item`.`tax_no`) END) AS 'tax_name' FROM `supplier_invoice_item`, `supplier_invoice`, " +
      //       "`unit` WHERE `supplier_invoice_item`.`unit_id` = `unit`.`unit_id` AND `supplier_invoice_item`.`invoice_no`" +
      //       " = `supplier_invoice`.`invoice_no` AND `supplier_invoice_item`.`status` = '1' AND `supplier_invoice`.`supplier_no` = '" + this.no +
      //       "' AND (`supplier_invoice_item`.`sub_item_number` = '' OR `supplier_invoice_item`.`sub_item_number` = '0'" +
      //       " OR `supplier_invoice_item`.`sub_item_number` = 'undefined') " + condition
      //     let obj = { cmd: 'getList', query: query };
      //     this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      //       .subscribe(data => {
      //         this.applicationConstants.appComp.hideBusyCursor();
      //         data.data['list'].forEach(element => {
      //           this.dp.push(element);
      //         });
      //         //console.log(this.dp);
      //         this.dp.forEach(element => {
      //           element.item_total = (Number(element.total_price) + Number(element.tax_amount) - Number(element.discount));
      //           element.invoice_date = (element.invoice_date).substring(0, 10);

      //           if (element.payment_method == 'cash')
      //             element.payment_method = this.Cash;
      //           else if (element.payment_method == 'credit')
      //             element.payment_method = this.credit;
      //           else if (element.payment_method == 'visa')
      //             element.payment_method = this.Visa;
      //           else if (element.payment_method == 'bank')
      //             element.payment_method = this.Bank;
      //         });

      //         this.dataSource = new MatTableDataSource(this.dp);
      //         this.dataSource.sort = this.sort;
      //       });
      //   });
    }

    let obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.dp = data.data['list'];
        //console.log(this.dp);
        this.dp.forEach(element => {
          element.item_total = (Number(element.total_price) + Number(element.tax_amount) - Number(element.discount));

          if (element.payment_method == 'cash')
            element.payment_method = this.Cash;
          else if (element.payment_method == 'credit')
            element.payment_method = this.credit;
          else if (element.payment_method == 'visa')
            element.payment_method = this.Visa;
          else if (element.payment_method == 'bank')
            element.payment_method = this.Bank;

          element.invoice_date = (element.invoice_date).substring(0, 10);

          if (this.type == 'customer' && this.model['rep_type'] == 'total')
            element.count = element.qty;

          // let query1 = "SELECT `sub_item`.`sub_item_no` FROM `sub_item` WHERE `sub_item`.`status` = '1'" +
          //   " AND `sub_item`.`sub_item_number` = '" + element.sub_item_number + "'";
          // let obj1 = { cmd: 'getList', query: query1 };
          // this.utils.invokeHttp(this.applicationConstants.generalFile, obj1)
          //   .subscribe(data => {
          //     this.applicationConstants.appComp.hideBusyCursor();
          //     //console.log(data.data['list']);
          //     element.sub_item_no = data.data['list']['0']['sub_item_no'];
          //   });

        });
        this.dataSource = new MatTableDataSource(this.dp);
        this.dataSource.sort = this.sort;
      });
  }

  print() {
    let html_data = '<table cellpadding="8" cellspacing="0">';
    // html_data += '<tr><td width="33%"> ' + this.title + ' </td></tr>';
    html_data += '<tr><td width="50%"> ' + this.Name + ': ' + this.name + '</td><td width="50%"> ' + this.Number + ': ' + this.no + '</td></tr>';
    html_data += '</table>';

    let form = (document.getElementById('form1') as HTMLFormElement);
    let table = (document.getElementById('item_table2') as HTMLTableElement);
    this.utils.printReport(html_data, [{ table: table }], form, 'PDF');
  }

  exportToExcel() {
    this.utils.exportToExcel(this.table.nativeElement, this.model.title);
  }

}
